import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import {
  Box,
} from "@material-ui/core";
import JudgeContainer from "@jumbo/Dashboards/HubbleContainer/JudgeContainer";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.hubbleJudge"} />, isActive: true },
];

const Judges = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.hubbleJudge" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box marginBottom={"10px"}>
            <div>
              <IntlMessages id="pages.hubbleJudge.description" />
            </div>
          </Box>

          <Divider />
          <div style={{ marginTop: 24 }}>
            <JudgeContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Judges;